import { Container, Table, Title } from '@mantine/core';
import { ICurrency } from '../../../../libraries/currencies';
import { formatCurrAmount } from '../../../utils/script';
import { EquipCurrencyDenom } from '../../../../libraries/dashboardV2';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';
import DisplayField from '../../../components/display-field';

interface DashboardCurrencyTableProps {
  currencyInfo: EquipCurrencyDenom;
  hideCoins?: boolean;
  lang: Language;
}

const DashboardCurrencyTable = ({ currencyInfo, hideCoins, lang }: DashboardCurrencyTableProps) => {
  const currencies = useSelector<AppState, ICurrency[]>(state => state.currencies.currencies);

  const currencyMatch = currencies.find(c => c.cid === currencyInfo.cid);

  if (!currencyInfo || !currencyMatch) {
    return <Title order={4}>No currency value found</Title>;
  }

  const getDenominationValue = (cindex: number) =>
    currencyMatch?.denominations.find(d => d.index === cindex)?.value ?? 0;

  if (hideCoins) {
    currencyInfo.denominations = currencyInfo.denominations.filter(
      elem => currencyMatch.mc_valueType[elem.cindex] === 2 || elem.qtySafe > 0
    );
  }

  const visibleDenominations = currencyInfo.denominations.filter(denom => denom.qtySafe > 0);

  return (
    <Container className="dashboard-table-container">
      <DisplayField title={'Total'} content={`${formatCurrAmount(currencyInfo.totalAmount, currencyMatch)}`} />

      <Table withRowBorders className="dashboard-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th className="dashboard-table-header">{lang.GLOBAL_DENOMINATION_MIN}</Table.Th>
            <Table.Th className="dashboard-table-header total">Total</Table.Th>
            <Table.Th className="dashboard-table-header quantity">{lang.GLOBAL_QUANTITY_MIN}</Table.Th>
          </Table.Tr>
        </Table.Thead>

        <Table.Tbody>
          {visibleDenominations.length === 0 ? (
            <Table.Tr>
              <Table.Td colSpan={3} style={{ textAlign: 'center', opacity: 0.6 }}>
                {lang.DASHBOARD_EMPTY}
              </Table.Td>
            </Table.Tr>
          ) : (
            visibleDenominations.map((denom, index) => {
              const value = getDenominationValue(denom.cindex);
              const total = denom.qtySafe * value;

              return (
                <Table.Tr key={index}>
                  <Table.Td className="dashboard-currency-table-denom">
                    <strong>{formatCurrAmount(value, currencyMatch)}</strong>
                  </Table.Td>
                  <Table.Td className="dashboard-currency-table-value">
                    {formatCurrAmount(total, currencyMatch)}
                  </Table.Td>
                  <Table.Td className="dashboard-currency-table-value">{`(${denom.qtySafe})`}</Table.Td>
                </Table.Tr>
              );
            })
          )}
        </Table.Tbody>
      </Table>
    </Container>
  );
};

export default DashboardCurrencyTable;
